var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.152,
    height: 19.152,
    viewBox: "0 0 19.152 19.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M7.106,17.952a.366.366,0,0,1-.184-.049.374.374,0,0,1-.19-.325V10.022a1.121,1.121,0,0,0-.377-.839L.627,4.095A1.873,1.873,0,0,1,0,2.693V1.122A1.123,1.123,0,0,1,1.122,0H16.83a1.123,1.123,0,0,1,1.122,1.122V2.693a1.873,1.873,0,0,1-.628,1.4L11.6,9.184a1.121,1.121,0,0,0-.377.838V14.91a1.127,1.127,0,0,1-.545.962L7.3,17.9a.365.365,0,0,1-.191.054ZM1.122.748a.375.375,0,0,0-.374.374V2.693a1.123,1.123,0,0,0,.375.841L6.852,8.624a1.873,1.873,0,0,1,.628,1.4v6.9l2.811-1.686a.378.378,0,0,0,.181-.321V10.022a1.872,1.872,0,0,1,.628-1.4l5.728-5.089a1.126,1.126,0,0,0,.375-.843V1.122A.375.375,0,0,0,16.83.748Z",
    transform: "translate(0 0)",
    stroke: "#8b0037",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.aab23397ffeaf7c8a97caccc658897c4.svg";
export { ForwardRef as ReactComponent };